/* =========================================================
   Collection navigation
   - Reveal category cards on scroll
   - Filter .cnav-filterable-product by category handle
   - Sync ?collection=handle in the URL
   - Notify listeners via `cnav:filter-changed`
   ========================================================= */

const initCollectionNavigationReveal = () => {
  if (!('IntersectionObserver' in window)) return;

  const cards = document.querySelectorAll('.cnav-card[reveal-on-scroll="true"]');
  if (!cards.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  cards.forEach((card) => observer.observe(card));
};

const setActiveCard = (cards, activeCard) => {
  cards.forEach((card) => {
    card.classList.toggle('is-active', card === activeCard);
  });
};

const syncBannerVisibility = () => {
  document.querySelectorAll(".cnav-filterable-product").forEach((el) => {
    if (!el.querySelector(".collection-inline-banner")) return;

    let anchor = el.previousElementSibling;
    while (anchor && !anchor.classList.contains("cnav-filterable-product")) {
      anchor = anchor.previousElementSibling;
    }

    if (!anchor) {
      el.hidden = false;
      return;
    }

    el.hidden =
      anchor.hidden || anchor.classList.contains("cnav-color-mismatch");
  });
};

const applyProductFilter = (handle) => {
  const products = document.querySelectorAll(".cnav-filterable-product");
  const seenProductHandles = new Set();

  products.forEach((product) => {
    product.classList.remove("cnav-striped-duplicate");
    product.hidden = false;

    const card = product.querySelector(".pcard");
    if (card) card.style.order = "";

    const isBanner = product.querySelector(".collection-inline-banner") !== null;
    if (isBanner) return;

    const categoryList = (product.getAttribute("data-categories") || "")
      .trim()
      .split(/s+/);

    if (!handle) {
      const productHandle = card?.getAttribute("data-handle");
      const isDuplicate =
        !!productHandle && seenProductHandles.has(productHandle);

      if (productHandle) seenProductHandles.add(productHandle);

      if (isDuplicate && categoryList.includes("sale-stripe")) {
        product.hidden = false;
        product.classList.add("cnav-striped-duplicate");
        if (card) card.style.order = "9999";
      } else {
        product.hidden = isDuplicate;
      }
      return;
    }

    product.hidden = !categoryList.includes(handle);
  });

  syncBannerVisibility();

  document.dispatchEvent(
    new CustomEvent("cnav:filter-changed", { detail: { handle } })
  );
};

const initCollectionNavigationFilter = () => {
  const cards = document.querySelectorAll('.cnav-card[data-collection-handle]');
  if (!cards.length) return;

  cards.forEach((card) => {
    card.addEventListener('click', () => {
      const collectionUrl = card.getAttribute('data-collection-url');

      // Navigate to the real Shopify collection so the collection's
      // own product set is rendered. This fixes switching between
      // collections such as 600GSM and 800GSM.
      if (collectionUrl) {
        window.location.href = collectionUrl;
        return;
      }

      // Fallback for cards without a collection URL.
      const isAlreadyActive = card.classList.contains('is-active');
      const nextHandle = isAlreadyActive
        ? null
        : card.getAttribute('data-collection-handle');

      setActiveCard(cards, isAlreadyActive ? null : card);
      applyProductFilter(nextHandle);
    });
  });

  // Restore state from URL on load
  const requestedHandle = new URLSearchParams(window.location.search).get(
    'collection'
  );

  const matchingCard = requestedHandle
    ? Array.from(cards).find(
        (card) => card.getAttribute('data-collection-handle') === requestedHandle
      )
    : null;

  if (matchingCard) setActiveCard(cards, matchingCard);
  applyProductFilter(matchingCard ? requestedHandle : null);
};

document.addEventListener("cnav:colors-updated", syncBannerVisibility);
initCollectionNavigationReveal();
initCollectionNavigationFilter();